import { combineReducers } from 'redux-immutable'
import modalReducer from './modal-reducer'
import confirmReducer from './confirm-reducer'

export default combineReducers({
  modal: modalReducer,
  confirm: confirmReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/modal/index.js